export default __webpack_public_path__ + "static/media/icons8-digger.d94db1a0.svg";